import React, { useEffect, useRef } from 'react';
import Webamp from 'webamp';
import { initialTracks } from './config';

function Winamp({ onClose, onMinimize }) {
  const ref = useRef(null);
  const webamp = useRef(null);
  useEffect(() => {
    const target = ref.current;
    if (!target) {
      return;
    }
    webamp.current = new Webamp({
      initialTracks,
    });
    webamp.current.renderWhenReady(target).then(() => {
      const webampEl = document.querySelector('#webamp');
      target.appendChild(webampEl);
      // Make the container not block clicks on desktop icons
      // but keep the actual Winamp UI interactive
      target.style.pointerEvents = 'none';
      if (webampEl) {
        webampEl.style.pointerEvents = 'auto';
      }
    });
    return () => {
      webamp.current.dispose();
      webamp.current = null;
    };
  }, []);
  useEffect(() => {
    if (webamp.current) {
      webamp.current.onClose(onClose);
      webamp.current.onMinimize(onMinimize);
    }
  });
  return (
    <div
      style={{ position: 'fixed', left: 0, top: 0, right: -3000, bottom: -350, zIndex: 0, pointerEvents: 'none' }}
      ref={ref}
    />
  );
}

export default Winamp;
